import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { URL_MAP } from '../../shared/urlMap';
import { environment as ENV } from '../../../environments/environment';

export interface BeneficiariosTarifaResponse {
  beneficiarios: any[];
  totalCuotaIva?: number;
}

@Injectable({
  providedIn: 'root',
})
export class BeneficiariosTarifaService {
  private apiUrl = `${ENV.HOST}${URL_MAP.API.BENEFICIARIOS_TARIFA_CONTRATO}`;

  constructor(private http: HttpClient) {}

  getBeneficiariosTarifa(
    numeroContrato: string
  ): Observable<BeneficiariosTarifaResponse> {
    const body = {
      jsonParametros: JSON.stringify({ prm_contrato: numeroContrato }),
    };
    return this.http.post<BeneficiariosTarifaResponse>(this.apiUrl, body);
  }
}
